import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { MitForbrugSendFejlData } from "./mit-forbrug-send-fejl-data.model";
import { MitForbrugSendFejlDialogComponent } from "./mit-forbrug-send-fejl-dialog.component";

// Provides i EForsyningFeaturesMitForbrugModule (og ikke "root") for at understøtte
// dynamisk oprettelse af MitForbrugSendFejlDialogComponent
@Injectable()
export class MitForbrugSendFejlDialog {
    constructor(private readonly dialog: MatDialog) {}

    public async open(): Promise<MitForbrugSendFejlData> {
        const matDialogConfig: MatDialogConfig = { width: "600px", maxWidth: "992px" };
        const dialog = this.dialog.open(MitForbrugSendFejlDialogComponent, matDialogConfig);
        return await dialog.afterClosed().toPromise();
    }
}
